module.exports = __webpack_public_path__ + "img/wash-white.82744d1d.svg";